<template>
	<div class="hello">
		<ul class="menu-simple">


			<template v-for="nav in navigations">
				<li class="head">
					{{ nav.title }}
				</li>

				<li v-for="n in nav.sub">
					<a href="javascript:void(0)" v-on:click="changeEditView(n)">
						<i class="typcn typcn-chevron-right-outline"></i>
						{{ n.name }}
					</a>
				</li>
			</template>
		</ul>

	</div>
</template>

<script>
    export default {
        name: 'userEditNavigations',
        props: ['id'],
        data () {
            return {
                navigations: []
            }
        },
	    watch: {
          '$route.params.id' () {
              this.init()
          }
	    },
	    mounted () {
            this.init()
	    },
	    methods: {
            init () {
                this.navigations =  [
                    {
                        title: this.$root.t.navigation.account,
                        sub: [
                            {route: 'edit_personal_informations', name: this.$root.t.navigation.personal_informations},
                            {route: 'prefences', name: this.$root.t.navigation.prefences},
                            {route: 'bank_accounts', name: this.$root.t.navigation.bank_accounts},
                        ]
                    },
                    {
                        title: this.$root.t.navigation.accounting,
                        sub: [
                            {route: 'balance', name: this.$root.t.user.balance},
                            {route: 'credits', name: this.$root.t.navigation.payables, query: { uid: this.$route.params.id  }, native: true},
                            {route: 'transactions', name: this.$root.t.navigation.transactions, query: { uid: this.$route.params.id  }, native: true},
                            {route: 'transactions', name: this.$root.t.navigation.deposit_transactions, query: { uid: this.$route.params.id, type: [11,12,13,15,30,31] }, native: true},
                            {route: 'transactions', name: this.$root.t.navigation.withdraw_transactions, query: { uid: this.$route.params.id, type: [9,10,16,17,32]  }, native: true},
                        ]
                    },
                    {
                        title: this.$root.t.promotions,
                        sub: [
                            {route: 'promotions', name: this.$root.t.promotions},
                            {route: 'transactions', name: this.$root.t.navigation.promotion_transactions, query: { uid: this.$route.params.id, type: [15,16]  }, native: true},
                        ]
                    },
                    {
                        title: this.$root.t.navigation.sport_bets,
                        sub: [
                            {route: 'bet_limits', name: this.$root.t.navigation.bet_slip_limits},
                            {route: 'bet_market_limits', name: this.$root.t.navigation.market_limitations},
                            {route: 'bets', name: this.$root.t.navigation.bet_history, query: { uid: this.$route.params.id  }, native: true},
                            {route: 'bet_trends', name: this.$root.t.navigation.bet_trends, query: { user: this.$route.params.id  }, native: true},
                            {route: 'bet_award_history', name: this.$root.t.navigation.bet_award_history, query: { user: this.$route.params.id  }, native: true},
                            {route: 'bet_analytics', name: this.$root.t.navigation.bet_analytics},

                        ]
                    },
                    {
                        title: this.$root.t.casino.title,
                        sub: [
                            {route: 'transactions', query: { uid: this.$route.params.id, type: [2,3,4,19,20,22] }, native: true, name: this.$root.t.navigation.casino_history},
                            {route: 'casino_trends', name: this.$root.t.navigation.casino_trends},
                            {route: 'casino_award_history', name: this.$root.t.navigation.casino_award_history},
                            {route: 'casino_analytics', name: this.$root.t.navigation.casino_analytics},
                        ]
                    },
                    {
                        title: this.$root.t.affiliate.title,
                        sub: [
                            {route: 'refers', name: this.$root.t.affiliate.refers},
                            {route: 'affiliate_history', name: this.$root.t.navigation.affiliate_history},
                        ]
                    }
                ];
            },
            changeEditView (v) {

                if(v.native) {
                    this.$router.push({ name: v.route, query: v.query });
                    document.body.style.overflow='auto';
                }else {
                    this.$route.query.view = v.route;
                    var qr = this.$route.query;
                    this.$router.push({ name: 'users', params: {id: this.id}, query: {} });
                    this.$router.push({ name: 'users', params: {id: this.id}, query: qr });
                    window.scrollTo(0,0);
                }


            }
	    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/widget/userEditNavigations.vue